<template>
  <div>
    <div class="list-actions text-right">
      <span class="icon-action" @click="exportProducts">
        <i class="far fa-arrow-to-bottom"></i> <span>Export</span>
      </span>
    </div>

    <div class="panel no-padding" v-if="data.length > 0">
      <searchBar placeholder="Search products" @sort="sort" :value="searchValue"
                 @search="search"></searchBar>

      <div :class="['loading-area', loading ? 'loading' : '']">
        <div :class="['loading-area__content', loading ? 'loading' : '']">
          <pagination :prev="prev" :next="next" :start="start" :end="end" :total="total"
                      @paginate="paginate"></pagination>

          <tableList :header="tableHeader" :data="tableData" :loading="loading" classes="no-hover"
                     @sort="orderBy"></tableList>

          <pagination :prev="prev" :next="next" :start="start" :end="end" :total="total"
                      @paginate="paginate"></pagination>
        </div>
      </div>
    </div>

    <div class="panel" v-if="data.length === 0">
      <p>Vendor does not current have any products.</p>
    </div>
  </div>
</template>

<script>
import client from '@/mixins/client'
import paginationUtils from '@/mixins/paginationUtils'
import moment from 'moment'

export default {
  mixins: [client, paginationUtils],
  props: [
    'vendor_id'
  ],
  data: function () {
    return {
      action: '/products/?expand=variants&vendor=' + this.vendor_id,
      sort: 'title',
      tableHeader: {
        currentSort: 'title',
        data: [
          {
            label: 'Product',
            class: 'full',
            sort: 'title'
          },
          // {
          //   label: 'SKU',
          //   class: 'large',
          //   sort: 'sku'
          // },
          {
            label: 'Price',
            class: 'medium'
          },
          {
            label: 'Cost',
            class: 'medium'
          },
          // {
          //   label: 'Type',
          //   class: 'large',
          //   sort: 'product_type'
          // },
          {
            label: 'Inventory',
            class: 'xlarge'
          },
          {
            label: 'Paid',
            class: 'small'
          },
          {
            label: 'Sold',
            class: 'small'
          },
          {
            label: 'Available',
            class: 'large'
          },
          {
            label: 'Commission',
            class: 'medium'
          },
          {
            label: 'Created',
            class: 'large',
            sort: 'created_at'
          }
        ]
      },
      tableData: []
    }
  },
  methods: {
    exportProducts () {
      let exportAction = '/products/?expand=variants&vendor=' + this.vendor_id
      if (this.$store.state.shop.myshopify_domain === 'deathwish-inc.myshopify.com' || this.$store.state.shop.myshopify_domain === 'fd7208-a5.myshopify.com' || this.$store.state.shop.myshopify_domain === 'the-harmonic-au.myshopify.com') {
        exportAction = '/products/variants/?vendor=' + this.vendor_id
      }

      this.request('get', exportAction, {
        format: 'csv'
      }).then((response) => {
        let downloadLink = document.createElement('a')

        downloadLink.href = response
        downloadLink.target = '_blank'

        document.body.appendChild(downloadLink)
        downloadLink.click()
        document.body.removeChild(downloadLink)

        this.loading = false
      })
    },
    go: function (id) {
      this.$router.push('/products/' + id)
    },
    buildTable () {
      for (let i = 0; i < this.data.length; i++) {
        if (this.$store.state.shop.myshopify_domain === 'lisco-ny.myshopify.com') {
          this.data[i].image = this.data[i].product.image
          this.data[i].title = this.data[i].product.title + '<br>' + this.data[i].title
          this.data[i].product_type = this.data[i].product.product_type
        }

        let primary = '<div class="grid-x align-middle"><div class="cell shrink">' +
          '<div class="table-list__image">'

        if (!this.isEmpty(this.data[i].image)) {
          let ext = this.data[i].image.split('.').pop()

          this.data[i].image = this.data[i].image.replace('.' + ext, '_100x100.' + ext)

          primary += '<div class="table-list__image__inner">'
          primary += '<img src="' + this.data[i].image + '">'
          primary += '</div>'
        } else {
          primary += '<div class="table-list__image__missing"><i class="fas fa-image"></i></div>'
        }

        primary += '</div></div><div class="cell auto"><span class="text-overflow">' + this.data[i].title + ' <br>' + this.data[i].sku + '</span></div></div>'

        let variantCount = 0
        let inventoryCount = 0
        let inventoryNotTracked = 0
        let sold = 0
        let paid = 0

        if (this.$store.state.shop.myshopify_domain !== 'lisco-ny.myshopify.com') {
          for (let j = 0; j < this.data[i]['variants'].length; j++) {
            variantCount++
            inventoryCount += this.data[i]['variants'][j]['inventory_quantity']
            sold += this.data[i]['variants'][j]['sold']
            paid += this.data[i]['variants'][j]['paid']

            if (this.data[i]['variants'][j]['inventory_management']) {
              inventoryNotTracked++
            }
          }
        } else {
          inventoryCount = this.data[i].inventory_quantity
          variantCount = 1
        }

        let inventory = inventoryCount + ' in stock'

        if (variantCount > 1) {
          inventory = inventory + ' for ' + variantCount + ' variants'
        }

        // if (inventoryNotTracked === variantCount) {
        //   inventory = '<span class="text-medium-gray-color">inventory not tracked</span>'
        // }

        let priceCol = {}

        let lowestPrice = 9999999999
        let itemCost = 0.0

        if (this.data[i].variants) {
          for (let j = 0; j < this.data[i].variants.length; j++) {
            if (this.data[i].variants[j].price < lowestPrice) {
              lowestPrice = this.data[i].variants[j].price
            }

            if (this.data[i].variants[j].cost_per_item !== null) {
              itemCost = this.data[i].variants[j].cost_per_item
            }
          }

          let price = this.formatMoney(lowestPrice)

          if (this.data[i].variants.length > 1) {
            price = 'starting at %s' % price
          }

          priceCol = {
            value: price,
            class: 'medium'
          }
        }

        /* commented out due to this error:
        " http://eslint.org/docs/rules/no-unused-vars  'skuCol' is assigned a value but never used "
        */
        // let skuCol = {
        //   value: this.data[i].sku,
        //   class: 'large'
        // }

        let availableCol = {}

        if (this.$store.state.shop.myshopify_domain === 'stylecolab-preloved.myshopify.com') {
          // skuCol = {}
          availableCol = {
            value: 'Start: ' + this.data[i].start_date + '<br>End: ' + this.data[i].end_date,
            class: 'large'
          }
        }

        let dateCol = {}

        if (this.$store.state.shop.myshopify_domain === 'dragonfly-maternity.myshopify.com') {
          // skuCol = {}
          dateCol = {
            value: moment(this.data[i].created_at).format('MMM D, YYYY'),
            class: 'large'
          }
        }

        let paidCol = {}

        if (this.$store.state.shop.myshopify_domain === 'dantes-luxury-lifestyle.myshopify.com') {
          paidCol = {
            value: paid,
            class: 'small'
          }
        }

        let costCol = {}

        if (this.$store.state.shop.myshopify_domain === 'the-backroom-4082.myshopify.com' || this.$store.state.shop.myshopify_domain === 'the-thrifting-den.myshopify.com') {
          itemCost = this.formatMoney(itemCost)

          costCol = {
            value: itemCost,
            class: 'medium'
          }
        }

        this.tableData.push({
          post: this.data[i].id,
          data: [
            {
              value: primary,
              class: 'full'
            },

            priceCol,
            costCol,
            // {
            //   value: this.data[i].product_type,
            //   class: 'large'
            // },
            {
              value: inventory,
              class: 'xlarge'
            },
            paidCol,
            {
              value: sold,
              class: 'small'
            },
            availableCol,
            {
              value: this.formatMoney(this.data[i].commission),
              class: 'medium',
              span: 'focus-text'
            },
            dateCol
          ]
        })
      }
    }
  },
  created () {
    if (this.$store.state.shop.myshopify_domain === 'dragonfly-maternity.myshopify.com') {
      // this.tableHeader.data[1] = {}
    } else {
      this.tableHeader.data[8] = {}
    }

    if (this.$store.state.shop.myshopify_domain === 'stylecolab-preloved.myshopify.com') {
      // this.tableHeader.data[1] = {}
    } else {
      this.tableHeader.data[6] = {}
    }

    if (this.$store.state.shop.myshopify_domain === 'dantes-luxury-lifestyle.myshopify.com') {
      // this.tableHeader.data[1] = {}
    } else {
      this.tableHeader.data[4] = {}
    }

    if (this.$store.state.shop.myshopify_domain === 'the-backroom-4082.myshopify.com' || this.$store.state.shop.myshopify_domain === 'the-thrifting-den.myshopify.com') {
      // this.tableHeader.data[1] = {}
    } else {
      this.tableHeader.data[2] = {}
    }

    if (this.$store.state.shop.myshopify_domain === 'lisco-ny.myshopify.com') {
      this.action = '/products/variants/?vendor=' + this.vendor_id
    }

    if (this.$store.state.shop.myshopify_domain === 'physicians-longevity.myshopify.com' || this.$store.state.shop.myshopify_domain === 'the-harmonic-au.myshopify.com') {
      this.action = '/products/?expand=variants'
    }

    if (this.$store.state.shop.myshopify_domain === '606dc3.myshopify.com') {
      this.sort = '-created'
    }

    this.getData()
  }
}
</script>

<style lang="scss">
@import '../../../styles/mixins';
@import '../../../styles/variables';
</style>



// WEBPACK FOOTER //
// src/pages/vendors/sections/products.vue